<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "patrol",
      key: "id",
      url: {
        get: "/admin/system/patrol",
        add: "/admin/system/patrol",
        edit: "/admin/system/patrol",
      },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "巡检名称",
          name: "patrolName",
          value: "",
          type: "input",
          width: "200px",
          rules: [{ required: true, trigger: "blur" }],
        },
        {
          label: "巡检维度类别",
          name: "patrolDimension",
          value: 1,
          type: "select",
          width: "240px",
          dropList: [
            { value: 1, name: "资产" },
            { value: 2, name: "巡检场景" },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
          onChange: this.onChangeType,
        },
        {
          label: "",
          name: "facilityList",
          value: "",
          type: "multiple",
          dropList: [],
          onChange: this.onCouponAlis,
        },
        {
          label: "",
          name: "facilityList1",
          value: "",
          type: "multiple",
          dropList: [],
          onChange: this.onCouponAlis,
        },

        {
          label: "巡检周期",
          name: "patrolInterval",
          value: "",
          type: "number",
          width: "200px",
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "周期单位",
          name: "timeUnit",
          value: "",
          type: "select",
          width: "240px",
          dropList: [
            // {
            //   value: 1,
            //   name: "分钟",
            // },
            {
              value: 2,
              name: "小时",
            },
            {
              value: 3,
              name: "天",
            },
            // {
            //   value: 4,
            //   name: "周",
            // },
            {
              value: 5,
              name: "月",
            },
            // {
            //   value: 6,
            //   name: "季度",
            // },
            // {
            //   value: 7,
            //   name: "年",
            // },
          ],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        {
          label: "巡检开始时间",
          name: "patrolBeginTime",
          value: "",
          type: "datetoday",
        },
        {
          label: "巡检内容",
          name: "patrolContent",
          value: "",
          type: "textarea",
          width: "400px",
        },
        // { label: "备注", name: "remark", value: "", type: "textarea",width:"400px" },
        {
          label: "负责人",
          name: "maintainerId",
          value: "",
          type: "select",
          width: "240px",
          dropList: [],
          rules: [{ required: true, trigger: "blur", type: "number" }],
        },
        // { label: '知识库标签', name: 'category_id', value: '', type: 'tree', dropList: [], rules: [{ required: true, trigger: 'blur', type: 'number' }] },
        // { label: '详情', name: 'detail', value: '', type: 'editor' },
      ],
      forms: {},
    };
  },
  created() {
    this.loaduserData();
    this.loadfacilityNoData();
    this.loadfacilityNoData1();
  },
  mounted() {
    this.onChangeType(1);
    this.forms.patrolDimension = 1;
    this.items[this.getItemIndex("patrolDimension")].value = 1;
  },
  methods: {
    handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      this.forms.facilityList = this.Listid;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/patrol`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    onCouponAlis(val) {
      let ass = val.join(",");
      this.Listid = ass;
    },
    loadfacilityNoData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/facility/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.id + element.facilityName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityList") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    loadfacilityNoData1() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/scene/selectList", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.sceneName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "facilityList1") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
    onChangeType(val) {
      if (val == 1) {
        this.items[this.getItemIndex("facilityList1")].type = "kong";
        this.items[this.getItemIndex("facilityList")].type = "multiple";
      }
      if (val == 2) {
        this.items[this.getItemIndex("facilityList1")].type = "multiple";
        this.items[this.getItemIndex("facilityList")].type = "kong";
      }
    },
    loaduserData() {
      // 通过pk查询字典数据
      let q = {};
      $utils.api.load("/admin/system/maiUser/lista", q).then((res) => {
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.id;
            xx.name = element.nickName;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.items.length; index++) {
            const element = this.items[index];
            if (element && element.name == "maintainerId") {
              // this.items[index]['dropList'] = dropList
              this.items[index]["dropList"] = (
                this.items[index]["dropList"] || []
              ).concat(dropList);
            }
          }
        }
      });
    },
  },
};
</script>
